export const getListeners = (listeners, loadBalancer) =>
  Object.values(listeners.LISTENERS_LIST || {}).filter((listener) =>
    listener.loadbalancers.find((lb) => lb.id === loadBalancer.id),
  );

export const getPools = (pools, loadBalancer) =>
  Object.values(pools.POOLS_LIST).filter((pool) =>
    pool.loadbalancers.find((lb) => lb.id === loadBalancer.id),
  );
